module.exports = __webpack_public_path__ + "static/media/videos-action-plan.cff06720.svg";